<template>
  <div>
    <el-container>
      <el-header>
        <div style="margin: 20px 0">
          <el-button type="primary" @click="openCreateWhite(1)" size="small">创建白名单</el-button>
        </div>
      </el-header>
      <el-main>
        <el-dialog  title="创建/编辑" :visible.sync="dialogFormVisible">
          <el-input placeholder="请输入ip地址，正确例子格式：192.168.1.*" v-model="ip" :maxlength="50" class="inputCss"></el-input>
          <br/><br/>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="qdCreateWhite">确 定</el-button>
          </div>
        </el-dialog>
        <template>
          <el-table
            :data="tableData"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              fixed
              prop="ip"
              label="IP地址"
              width="380">
            </el-table-column>
            <el-table-column
              prop="state"
              label="状态操作"
              width="220">
              <template slot-scope="scope">
                <el-button @click="{{(scope.row.state?cz(1,scope.row._id):cz(2,scope.row._id))}}" type="text" size="small">{{(scope.row.state?'停用':'启用')}}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="updateTime"
              :formatter="formatTime"
              label="最后更新时间"
              width="260">
            </el-table-column>
            <el-table-column
              prop="createTime"
              :formatter="formatTime"
              label="创建时间"
              width="260">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-button @click="updateWhite(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  export default {
    name: 'whiteList',
    data(){
      return {
        dialogFormVisible:false,
        tableData:[],
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        ip:"",
        state:true,
        isType:1,
        isId:"",
        divHeight:500
      }
    },
    methods:{
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy-MM-dd hh:mm:ss";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      openCreateWhite:function (val) {
        this.isType = val;
        this.dialogFormVisible = true;
      },
      qdCreateWhite:function () {
        this.isAjax();
      },
      isAjax:async function(){
        var _this = this;
        if(this.isType == 1){
          if(!this.isValidIP(_this.ip)){
            this.$message({
              message: "ip地址格式错误，正确格式：192.168.1.*",
              type: 'warning'
            });
            return false;
          }
        }
        await this.$axios.post('/root/whiteListMessage',{
          "t":_this.isType,
          "ip":_this.ip,
          "state":_this.state,
          "id":_this.isId
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.$message({
              message: response.message,
              type: 'success'
            });
            this.addWhiteList();
            this.dialogFormVisible = false;
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
          this.ip = "";
          this.state = true;
          this.isId = "";
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      addWhiteList:async function(){
        await this.$axios.post('/root/addWhiteList',{}).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.tableData = response.data[0];
            this.allcount0 = response.data[1];
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
        this.divHeight = window.innerHeight-158;
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.addWhiteList();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.addWhiteList();
      },
      updateWhite(index, row) {
        this.isId = row._id;
        this.ip = row.ip;
        this.state = row.state;
        this.openCreateWhite(3);
      },
      isValidIP(ip) {
        var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
        return reg.test(ip);
      },
      cz(val,id){
        var isState = true;
        this.isId = id;
        if(val == 1){
          isState = false;
        }else if(val == 2){
          isState = true;
        }
        this.state = isState;
        this.isType = 2;
        this.isAjax();
      }
    },
    mounted(){
      this.addWhiteList();
    }
  }
</script>
<style scoped>
  body{
    padding: 0;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/main/whiteList.vue